module.exports = __webpack_public_path__ + "img/ico-bone.96249230.png";